import axios from "axios";
import { Toast } from "../../util/Toast";
import * as ActionType from "./seller.type";

export const getCoinSellerHistory = (id , start , limit) => (dispatch) => {

  axios
    .get(`coinSellerHistory/history/${id}?start=${start}&limit=${limit}`)
    .then((res) => {

      dispatch({ type: ActionType.GET_HISTORY, payload: {data : res.data.coinSeller ,total :res.data.total} });
    })
    .catch((error) => Toast("error", error.message));
};

export const createCoinData = (data) => (dispatch) => {
  return axios
    .post(`coinSeller/coinSellerToUser`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Diamond sent successfully!");
        dispatch({
          type: ActionType.COIN_DATA_CREATE,
          payload: res.data.sellerHistory,
        });
        return true;
      }

      Toast("error", res.data.message);
      return false;
    })
    .catch((error) => {
      Toast("error", error.response?.data?.message || "Unable to send diamonds.");
      return false;
    });
};

// USER HISTORY_TABLE

export const getUserHistory = (id , coinSellerId) => (dispatch) => {
  
  axios
    .get(`coinSellerHistory/userHistory?userId=${id}&coinSellerId=${coinSellerId}`)
    .then((res) => {
      
      console.log(res.data);
      dispatch({
        type: ActionType.HISTORY_TABLE,
        payload: res.data,
      });
    })
    .catch((error) => Toast("error", error.message));
};
